"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadTiltUpdater = void 0;
const TiltUpdater_1 = require("./TiltUpdater");
function loadTiltUpdater(tsParticles) {
    tsParticles.addParticleUpdater("tilt", () => new TiltUpdater_1.TiltUpdater());
}
exports.loadTiltUpdater = loadTiltUpdater;
